import script from "./EcommerceCompanyInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceCompanyInfo.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceCompanyInfo.vue?vue&type=style&index=0&id=096e6330&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-096e6330"]])

export default __exports__